import { SxProps, Theme } from "@mui/material/styles";

export const container: SxProps<Theme> = {
    maxWidth: "1000px",
    margin: "0 auto",
    py: { xs: 5, sm: 6, md: 7 },
    px: { xs: 3, sm: 5, md: 7.5 },
    textAlign: "center",
};

export const introText: SxProps<Theme> = {
    fontFamily: "HsvSlab",
    fontWeight: "400",
    fontSize: {
        xs: "1.25rem",
        sm: "1.5rem",
        md: "1.75rem",
    },
    lineHeight: 1.4,
    marginBottom: {
        xs: "8px",
        md: "12px",
    },
    color: "rgba(255, 255, 255, 0.85)",
    letterSpacing: "0.01em",
};

export const factText: SxProps<Theme> = {
    fontFamily: "HsvSlab",
    fontWeight: "700",
    fontSize: {
        xs: "1.5rem",
        sm: "1.875rem",
        md: "2.25rem",
    },
    lineHeight: 1.4,
    marginBottom: {
        xs: "40px",
        md: "50px",
    },
    color: "white",
    letterSpacing: "0.01em",
};

export const highlightNumber: SxProps<Theme> = {
    color: "#B4A36E",
    fontWeight: "900",
    fontSize: "1.15em",
};

export const timedBox: SxProps<Theme> = {
    display: "flex",
    flexDirection: "column",
    gap: {
        xs: "28px",
        md: "32px",
    },
    padding: {
        xs: "50px 30px",
        md: "70px 50px",
    },
    backgroundColor: "rgba(0, 0, 0, 0.5)",
    borderRadius: "16px",
    border: "2px solid rgba(255, 255, 255, 0.2)",
    backdropFilter: "blur(10px)",
};

export const timeContainer: SxProps<Theme> = {
    display: "grid",
    gridTemplateColumns: "1fr auto 1fr",
    alignItems: "center",
};

export const countdownLabel: SxProps<Theme> = {
    fontFamily: "HsvSlab",
    fontWeight: "500",
    fontSize: {
        xs: "1.125rem",
        sm: "1.25rem",
        md: "1.375rem",
    },
    color: "rgba(255, 255, 255, 0.85)",
    letterSpacing: "0.02em",
    marginBottom: "-8px",
};

export const timeNumber: SxProps<Theme> = {
    fontFamily: "HsvSans",
    fontWeight: "900",
    fontSize: {
        xs: "3rem",
        sm: "4rem",
        md: "5rem",
    },
    color: "#B4A36E",
    letterSpacing: "0.08em",
    gridColumn: "2",
    textAlign: "right",
    paddingRight: "6px",
};

export const timeLabel: SxProps<Theme> = {
    fontFamily: "HsvSans",
    fontWeight: "700",
    fontSize: {
        xs: "1.5rem",
        sm: "2rem",
        md: "2.5rem",
    },
    color: "rgba(255, 255, 255, 0.9)",
    letterSpacing: "0.06em",
    textShadow: "0 2px 10px rgba(0,0,0,0.5)",
    gridColumn: "3",
    justifySelf: "start",
    paddingLeft: "6px",
};

export const countdownBox: SxProps<Theme> = {
    display: "inline-block",
    padding: "12px 32px",
    backgroundColor: "rgba(0, 102, 178, 0.3)",
    borderRadius: "8px",
    border: "2px solid #0066B2",
};

export const countdownText: SxProps<Theme> = {
    fontFamily: "HsvSans",
    fontWeight: "900",
    fontSize: {
        xs: "1.75rem",
        sm: "2.25rem",
        md: "2.75rem",
    },
    color: "#B4A36E",
    letterSpacing: "0.08em",
};

export const revealedText1: SxProps<Theme> = {
    fontFamily: "HsvSlab",
    fontWeight: "600",
    fontSize: {
        xs: "1.375rem",
        sm: "1.75rem",
        md: "2.125rem",
    },
    lineHeight: 1.5,
    marginBottom: "24px",
    color: "rgba(255, 255, 255, 0.9)",
    letterSpacing: "0.01em",
};

export const revealedText2: SxProps<Theme> = {
    fontFamily: "HsvSlab",
    fontWeight: "800",
    fontSize: {
        xs: "1.625rem",
        sm: "2.125rem",
        md: "2.625rem",
    },
    lineHeight: 1.4,
    marginBottom: {
        xs: "60px",
        md: "80px",
    },
    color: "white",
    letterSpacing: "0.02em",
};

export const videoContainer: SxProps<Theme> = {
    position: "relative",
    zIndex: 1,
    overflow: "hidden",
    backgroundColor: "#000",
    aspectRatio: "16 / 9",
};

export const video: React.CSSProperties = {
    width: "100%",
    height: "100%",
};
